import datos from "src/services/datos";

/**
 * Llama al endpoint /comprobantes/guarda para generar
 * comprobantes de servicio de guarda para los clientes
 * y el período indicado.
 *
 * @param {object} params
 * @param {number[]} params.id_cuentas  - Array de IDs de cuentas a procesar
 * @param {string}  params.fecha_desde  - Fecha inicio (YYYY-MM-DD)
 * @param {string}  params.fecha_hasta  - Fecha fin (YYYY-MM-DD)
 *
 * @returns {Promise} Respuesta del servicio
 */
export const procesarServicioGuarda = async ({ id_cuentas, fecha_desde, fecha_hasta }) => {
  const service = new datos("comprobantes");
  const response = await service.comprobantesGuarda({
    id_cuentas,
    fecha_desde,
    fecha_hasta,
  });
  return response;
};
